/* Show each review's product name from Judge.me's existing product-image label.
   This only changes the draft presentation; review content and app settings stay intact. */
(() => {
  const attached = new WeakSet();
  const addProductNames = (carousel) => {
    carousel.querySelectorAll('.jdgm-carousel-item__product').forEach((product) => {
      if (product.querySelector('.snt-review-product-name')) return;
      const name = product.querySelector('.jdgm-carousel-item__product-image')?.getAttribute('alt')?.trim();
      if (!name) return;
      const existing = product.querySelector('.jdgm-carousel-item__product-title');
      if (existing && getComputedStyle(existing).display !== 'none') return;
      const label = document.createElement('span');
      label.className = 'snt-review-product-name';
      label.textContent = name;
      product.append(label);
    });
  };
  const initialize = () => {
    document.querySelectorAll('.snt-review-carousel').forEach((carousel) => {
      if (attached.has(carousel)) return;
      attached.add(carousel);
      addProductNames(carousel);
      const observer = new MutationObserver(() => addProductNames(carousel));
      observer.observe(carousel, { childList: true, subtree: true });
      carousel.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
